


import React, { useEffect, useState } from "react"
import { addDoc, collection, DocumentData, getDocs, onSnapshot, query, QuerySnapshot, where} from "firebase/firestore";
import "./PopupAddNonProjectTaskSheduleBlock.css"
import { useDispatch, useSelector } from "react-redux";
import { Project, ProjectTask, ProjectTaskScheduleBlock } from "../../FirebaseModel/Project";
import { Organization } from "../../FirebaseModel/Organization";
import { Role } from "../../FirebaseModel/Role";
import { Client } from "../../FirebaseModel/Client";
import ClientDropdown from "../../Components/ClientDropdown/ClientDropdown";
import PersonDropdown from "../../Components/PersonDropdown/PersonDropdown";
import { prettyNum, forceNumeric, prettyCurrency, forceDecimal, shortDate } from "../../Utils/formatting";
import { sharedFirestore } from "../../Utils/SharedFirebase";
import DropdownButton from "../../Components/DropdownButton/DropdownButton";
import { saveClientAttributeChange } from "../../Utils/SaveClientFunctions";
import { UndoStackEntry, UndoStackEntryObjectType, UndoStackEntryType } from "../../Utils/UndoStackEntry";
import { bindActionCreators } from "redux";
import ActionCreators from "../../Redux/ActionCreators";
import { ClientContact } from "../../FirebaseModel/ClientContact";
import { Person, PersonNonProjectTask, PersonNonProjectTaskScheduleBlock } from "../../FirebaseModel/Person";
import DatePicker from  "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { saveProjectAttributeChange } from "../../Utils/SaveProjectFunctions";
import { savePersonAttributeChange } from "../../Utils/SavePersonFunctions";


const uuid = require('uuid');

interface PopupAddNonProjectTaskSheduleBlockProps{
	personNonProjectTaskScheduleBlock?:PersonNonProjectTaskScheduleBlock;
	personID?:string;
	startDate?:string;

	onCancel:()=>void;
	onSave:(taskBlock:PersonNonProjectTaskScheduleBlock|null) =>void;
}

export default function PopupAddNonProjectTaskSheduleBlock(props:PopupAddNonProjectTaskSheduleBlockProps){

  const organization = useSelector((state:{organization:Organization}) => state.organization)
  const projects = useSelector((state:{projects:Project[]}) => state.projects)
  const roles = useSelector((state:{roles:Role[]}) => state.roles)
  const persons = useSelector((state:{persons:Person[]}) => state.persons)

	const [person, setPerson] = useState<Person|null>(null);

	const [tasks, setTasks] = useState<PersonNonProjectTask[]>([]);
	const [selectedTask, setSelectedTask] = useState<PersonNonProjectTask|null>(null);

	const [startDate, setStartDate] = useState<string>(props.startDate??shortDate(new Date()));
	const [endDate, setEndDate] = useState<string>(props.startDate??shortDate(new Date()));
	const [dailyPlannedHours, setDailyPlannedHours] = useState<number[]|undefined>(props.personNonProjectTaskScheduleBlock?.dailyPlannedHours??undefined);

	useEffect(() =>{
		let person = persons.find((person) => person.id == (props.personID??props.personNonProjectTaskScheduleBlock!.personID));
		setPerson(person!);

		setDailyPlannedHours(props.personNonProjectTaskScheduleBlock?.dailyPlannedHours??undefined);
	
		setStartDate(props.personNonProjectTaskScheduleBlock?.startDate??props.startDate??shortDate(new Date()));
		setEndDate(props.personNonProjectTaskScheduleBlock?.endDate??props.startDate??shortDate(new Date()));
	},[props.personID, props.personNonProjectTaskScheduleBlock])

	useEffect(() =>{
		if(person){
			let tasks = person.nonProjectTasks;
			setTasks(tasks);

		}else{
			setTasks([]);
		}
	},[person, props.personNonProjectTaskScheduleBlock])

	useEffect(() =>{
		if(person){
			let selectedTask = tasks.find((task) => task.id == props.personNonProjectTaskScheduleBlock?.taskID);
			if(selectedTask){
				setSelectedTask(selectedTask);
			}

			if(!selectedTask && tasks.length > 0){
				setSelectedTask(tasks[0]);
			}
		}
	},[person, props.personNonProjectTaskScheduleBlock,tasks])

  const dispatch = useDispatch();
  const AC = bindActionCreators({
    submitUndoStackEntry:ActionCreators.submitUndoStackEntry},dispatch);
		

		useEffect(() =>{
			// building the planned daily hours. if its unset then it is 8 hours for weekday and 0 for weekend
			let newDailyPlannedHours = [];
			let currentDate = new Date(startDate);
			let endDateDate = new Date(endDate);
			while(currentDate <= endDateDate){
				if(currentDate.getDay() == 0 || currentDate.getDay() == 6){
					newDailyPlannedHours.push(0);
				}else{
					newDailyPlannedHours.push(8);
				}
				currentDate = addDays(currentDate,1);
			}

			let oldDaiplyPlannedHours = [...dailyPlannedHours??[]];
			// remove any left over entries so that there are only as many as newDailyPannedHours
			oldDaiplyPlannedHours.splice(newDailyPlannedHours.length,oldDaiplyPlannedHours.length - newDailyPlannedHours.length);

			//now only overwrite if the dailyPlannedHours[i] is unset
			for(let i = 0; i < newDailyPlannedHours.length; i++){
				if(oldDaiplyPlannedHours[i] == undefined){
					oldDaiplyPlannedHours[i] = newDailyPlannedHours[i];
				}
			}

			//add any rows if the newDailyPlannedHours is longer than the dailyPlannedHours
			for(let i = oldDaiplyPlannedHours.length; i < newDailyPlannedHours.length; i++){
				oldDaiplyPlannedHours.push(newDailyPlannedHours[i]);
			}

			setDailyPlannedHours(oldDaiplyPlannedHours);
		},[startDate,endDate]);


		useEffect(() =>{
			if(props.personNonProjectTaskScheduleBlock){
				setDailyPlannedHours(props.personNonProjectTaskScheduleBlock.dailyPlannedHours);
				setStartDate(props.personNonProjectTaskScheduleBlock.startDate);
				setEndDate(props.personNonProjectTaskScheduleBlock.endDate);
			}
		},[props.personNonProjectTaskScheduleBlock])

		// a function that returns a date offset by a certain number of days
		const addDays = function(date:Date, days:number) {
			var date = new Date(date.valueOf());
			date.setDate(date.getDate() + days);
			return date;
		}

	const saveNewProjectTaskScheduleBlock = () =>{
		return new Promise<PersonNonProjectTaskScheduleBlock>((resolve,reject) =>{

			let taskBlockDocData:PersonNonProjectTaskScheduleBlock = {
				personID: person!.id,
				taskID: selectedTask!.id,
				startDate: startDate,
				endDate: endDate,
				dailyPlannedHours: dailyPlannedHours!,
				id: uuid.v4()
			}

			let nonProjectTasks = [...person!.nonProjectTasks];
			let task = nonProjectTasks.find((task) => task.id == selectedTask!.id)!;

			task.scheduleBlocks.push(taskBlockDocData);

			savePersonAttributeChange(person!, "nonProjectTasks", nonProjectTasks,(entry) =>{
				AC.submitUndoStackEntry(entry);
			}).then(() =>{
				resolve(taskBlockDocData);
			});			
		})
	}

	const updateProjectTaskScheduleBlock = () =>{
		return new Promise<PersonNonProjectTaskScheduleBlock>((resolve,reject) =>{
			let taskBlockDocData:PersonNonProjectTaskScheduleBlock = {
				taskID: selectedTask!.id,
				personID: person!.id,
				startDate: startDate,
				endDate: endDate,
				dailyPlannedHours: dailyPlannedHours!,
				id: props.personNonProjectTaskScheduleBlock!.id
			}

			let nonProjectTasks = [...person!.nonProjectTasks];
			let prevTask = nonProjectTasks.find((task) => task.id == props.personNonProjectTaskScheduleBlock!.taskID)!;
			let task = nonProjectTasks.find((task) => task.id == selectedTask!.id)!;

			//if prevTask id is different than selected task id then remove the taskBlock from the prevTask
			if(prevTask.id != task.id){
				let taskBlockIndex = prevTask.scheduleBlocks.indexOf(props.personNonProjectTaskScheduleBlock!);
				prevTask.scheduleBlocks.splice(taskBlockIndex,1);
			}

			let taskBlock = task.scheduleBlocks.find((taskBlock) => taskBlock.id == props.personNonProjectTaskScheduleBlock!.id)!;
			let taskBlockIndex = task.scheduleBlocks.indexOf(taskBlock);
			if(taskBlockIndex == -1){
				task.scheduleBlocks.push(taskBlockDocData);
			}else{
				task.scheduleBlocks[taskBlockIndex] = taskBlockDocData;
			}

			savePersonAttributeChange(person!, "nonProjectTasks", nonProjectTasks,(entry) =>{
				AC.submitUndoStackEntry(entry);
			}).then(() =>{
				resolve(taskBlockDocData);
			});
		})
	}

	const deleteProjectTaskScheduleBlock = () =>{
		return new Promise<void>((resolve,reject) =>{
			let nonProjectTasks = [...person!.nonProjectTasks];
			let task = nonProjectTasks.find((task) => task.id == props.personNonProjectTaskScheduleBlock!.taskID)!;
			let taskBlockIndex = task.scheduleBlocks.indexOf(props.personNonProjectTaskScheduleBlock!);
			task.scheduleBlocks.splice(taskBlockIndex,1);

			savePersonAttributeChange(person!, "nonProjectTasks", nonProjectTasks,(entry) =>{
				AC.submitUndoStackEntry(entry);
			}).then(() =>{
				resolve();
			});
		})
	}


	const dayOfWeek = ["S","M","T","W","T","F","S"]

	const [clearingForm, setClearingForm] = useState(false);

  return (
    <div className={`popup PopupAddNonProjectTaskSheduleBlock`}>
			<h1>Schedule {person?.name} non project task"</h1>
			{clearingForm == false && (
				<div className="content">

					{props.personNonProjectTaskScheduleBlock && (
						<button className="deleteButton" onClick={() => {
							deleteProjectTaskScheduleBlock().then(() =>{
								props.onSave(null);
							})						
						}}>Remove From Schedule</button>
					)}

					<div className="topArea">

						<div className="row">
							<div className="col">
								<div className="label">Task</div>
								<select className={`task`}
									value={selectedTask?selectedTask.id:""}
									onChange={(event) =>{
										let task = tasks.find((task) => task.id == event.target.value)!;
										setSelectedTask(task);
									}}>
									{tasks.map((task) =>(
										<option value={task.id}>{task.name}</option>
									))}
								</select>
							</div>

							<div className="col">
								<div className="label">Start Date</div>
				        <DatePicker 
				          selected={(new Date(startDate))}
				          onChange={(date:Date) =>{
				            if(date){
											let dateString = shortDate(date);
											setStartDate(dateString);
				            }
				          }}></DatePicker>
							</div>

							<div className="col">
								<div className="label">End Date</div>
				        <DatePicker 
				          selected={(new Date(endDate))}
				          onChange={(date:Date) =>{
				            if(date){
											let dateString = shortDate(date);
											setEndDate(dateString);
				            }
				          }}></DatePicker>
							</div>
						</div>
					</div>

					<h1>Daily Breakdown</h1>

					<div className="bottomArea">
						<table>
							<thead>
								<tr>
									<th>Date</th>
									<th>Hours</th>
								</tr>
							</thead>
							<tbody>
								{dailyPlannedHours && dailyPlannedHours.map((hours,index) =>(
									<tr className={`${(addDays(new Date(startDate),index).getDay()==0||addDays(new Date(startDate),index).getDay()==6)?"weekend":""}`}>
										<td>{shortDate(addDays(new Date(startDate),index))} - {dayOfWeek[addDays(new Date(startDate),index).getDay()]}</td>
										<td>
											<input type="number" 
												value={hours} 
												max={10}
												min={0}
												onChange={(event) =>{
												let newDailyPlannedHours = [...dailyPlannedHours];
												newDailyPlannedHours[index] = parseFloat(event.target.value);
												setDailyPlannedHours(newDailyPlannedHours);
											}}
											onKeyPress={(event) =>{
												forceDecimal(event);
											}}></input>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			)}

			<div className="floatingButtons">
				<div className="buttonCancel"
					onClick={() =>{
						props.onCancel();
					}}>Cancel</div>
				<div className="buttonSave"
					onClick={() =>{
						if(props.personNonProjectTaskScheduleBlock){
							updateProjectTaskScheduleBlock().then((taskBlock) =>{
								props.onSave(taskBlock);
							});
						}else{
							saveNewProjectTaskScheduleBlock().then((taskBlock) =>{
								props.onSave(taskBlock);
							});
						}
					}}>Save &amp; Close</div>
			</div>
		</div>
  )
}